import { ChipProps } from '@mui/material';

export type OperationalStatus =
  | 'WORKING'
  | 'IDLE'
  | 'LOCKED'
  | 'LUNCH'
  | 'BREAK'
  | 'BATHROOM'
  | 'CLOCKED_OUT'
  | 'OFFLINE'
  | 'EMERGENCY'
  | 'ATTENTION';

export function statusColor(status: string): ChipProps['color'] {
  switch (status) {
    case 'WORKING':
      return 'success';
    case 'IDLE':
      return 'warning';
    case 'LOCKED':
      return 'warning';
    case 'LUNCH':
    case 'BREAK':
    case 'BATHROOM':
      return 'info';
    case 'EMERGENCY':
      return 'error';
    case 'OFFLINE':
    case 'CLOCKED_OUT':
      return 'default';
    case 'ATTENTION':
      return 'warning';
    default:
      return 'default';
  }
}

export function agentHealthColor(health: string): ChipProps['color'] {
  switch (health) {
    case 'healthy':
      return 'success';
    case 'outdated':
    case 'service_not_reporting':
      return 'warning';
    case 'offline':
      return 'error';
    default:
      return 'default';
  }
}
